<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Ball Park</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<p class="dedication">This novel is dedicated to a certain gentleman</p>
<p class="dedication">who reads crime fiction voraciously</p>
<p class="dedication-space-after">and collects these books with a grand passion.</p>
<p class="dedication">Steele Curry, you are a writer’s reader.</p>
<p class="dedication">While you have read thousands of crime novels,</p>
<p class="dedication">know that this one is dedicated to you</p>
<p class="dedication">with boundless appreciation.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9bad30e8